import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/config/site";
import { Wordmark } from "@/components/Navbar";
import { ArrowRight } from "lucide-react";

const formatError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
};

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-sm text-charcoal placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-forest/25 focus:border-forest transition";

  return (
    <div className="min-h-screen bg-offwhite flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="bg-white border border-gray-200 rounded-lg p-8">
          <Wordmark />
          <p className="mt-2 text-[12px] text-zinc-500">Administration access</p>
          <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
            <label className="block">
              <span className="block text-[12px] font-semibold text-charcoal mb-1.5">Email</span>
              <input type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" placeholder="admin email" />
            </label>
            <label className="block">
              <span className="block text-[12px] font-semibold text-charcoal mb-1.5">Password</span>
              <input type="password" required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" placeholder="password" />
            </label>
            {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full inline-flex justify-center items-center gap-2 bg-forest text-white font-semibold text-sm px-6 py-3 rounded-md hover:bg-forest-mid transition-colors disabled:opacity-60"
              data-testid="admin-login-submit-button"
            >
              {loading ? "Signing in…" : "Sign In"}
              <ArrowRight size={14} />
            </button>
          </form>
        </div>
        <p className="mt-5 text-center">
          <Link to="/" className="text-[13px] text-zinc-500 hover:text-forest transition-colors" data-testid="admin-back-to-site-link">
            ← Back to Westline Technologies
          </Link>
        </p>
      </div>
    </div>
  );
}
